<template>
  <div>
    <section class="producer-list">
      <div class="container">
        <div class="row align-items-center">
          <template v-for="(page, index) in pages">
            <div v-bind:key="index" class="col-12 col-md-6 col-lg-4 producer" data-aos="fade-in">
              <router-link :to="{ name: 'producer', params: { slug: page.slug }}" :title="'Link: ' + page.title">
                <img v-if="page.thumbnail" v-bind:src="page.thumbnail.url" v-bind:alt="page.title" style="filter:invert(1)"/>
                <h3 v-else>{{ page.title }}</h3>
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'ProducerList',
    data() {
      return {
        pageNumber: 1,
        paginationInterval: 100,
        pages: []
      };
    },
    methods: {
      reset: function () {
        this.pages = [];
      },
      load: function () {
        const pagination = {
          page: this.pageNumber,
          pagination_interval: this.paginationInterval
        };

        const filters = [
          {
            property: 'page_type_id',
            value: 3,
            operator: '='
          }
        ];

        this.$root.$api.getPages(pagination, filters)
          .then(response => {
            if (response.data != null) {
              const pages = response.data.pages;
              this.pages = this.$root.sortByProperty(pages, 'title')
            }
          }).catch(error => {
          console.log(error);
        })
      },
    },
    created: function () {
      this.load();
    }
  }
</script>
